'use client';
import Hamburger from 'hamburger-react';
import React from 'react';
import { useState } from 'react';
import './hamburger.css';
import '../../root.css';
import { Link } from 'react-router-dom';
import lang from '../../assets/icons/langIconPrimary.svg';
import theme from '../../assets/icons/themeIconPrimary.svg';


const HamburgerComp = () => {

    const [open,setOpen] = useState(false);

    return ( 
        <>
        <div className="hamburgerToggle">
        <Hamburger color='#AD4D34' toggled={open} toggle={setOpen}/>
        {open && <div className="burgerMenu">
                <header>
                    <nav>
                        <Hamburger color='#FFFDF1' toggled={open} toggle={setOpen}/>
                    </nav>
                </header>
                <div className="burgerMenuCont">
                    <div className="burgerMenuLeft">
                        <Link className='burgerMenuItem' to="/">Home</Link>
                        <Link className='burgerMenuItem' to="/Book">Book</Link>
                        <Link className='burgerMenuItem' to="/Explore">Explore</Link>
                        <Link className='burgerMenuItem' to="/History">History</Link>
                        <Link className='burgerMenuItem' to="/Info">Info</Link>
                    </div>
                    <div className="burgerMenuRight">
                        <div className="headControls">
                            <div className="headControl">
                                <img src={lang} alt="Language icon" />
                            </div>
                            <div className="headControl">
                                <img src={theme} alt="Theme icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            </div>
        </>
     );
}
 
export default HamburgerComp;